import { Controller } from '@hotwired/stimulus';

export default class ProductCardController extends Controller {
  static targets = ['form', 'modalLink'];
  static values = {
    featured: Boolean,
    enabled: Boolean
  }

  toggleProductEnabled(e) {
    const isFeatured = this.featuredValue
    const isCurrentlyEnabled = this.enabledValue
    
    // block disabling of featured product, we will only toggle if
    // confirmed in the modal
    if (isFeatured && isCurrentlyEnabled) {
      e.preventDefault()
      e.stopImmediatePropagation()
      this.modalLinkTarget.click();
      return
    }
    // allow normal toggle behavior
    this.formTarget.requestSubmit();
  }
}
